// app.config.ts
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './core/auth.interceptor';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getVertexAI, provideVertexAI } from '@angular/fire/vertexai-preview';
import { environment } from '../environments/environment';
import { provideServiceWorker } from '@angular/service-worker';
import { SecureInterceptor } from './core/sec.interceptor';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { ReqInterceptor } from './core/req.interceptor';
import { AuthService } from './services/auth.service';

export function initializeAuthFactory(authService: AuthService): () => Promise<void> {
  return () => authService.initializeAuth();
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuthFactory,
      deps: [AuthService],
      multi: true
    },
    provideRouter(routes),
    provideAnimationsAsync(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
    UserTrackingService,
    provideFirestore(() => getFirestore('recognition-system')),
    provideFunctions(() => getFunctions()),
    provideStorage(() => getStorage()),
    provideVertexAI(() => getVertexAI()),
    { provide: HTTP_INTERCEPTORS, useClass: SecureInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ReqInterceptor, multi: true },
    importProvidersFrom(MonacoEditorModule.forRoot({
      baseUrl: '/assets/monaco/min/vs',
      defaultOptions: { scrollBeyondLastLine: false },
      onMonacoLoad: () => { }
    }))
  ]
};